import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/logo.png",
  alt: "Location Garde-meuble",
  width: "50",
  height: "50"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.3em","color":"white","text-transform":"none","padding":"0.3em 0.5em"} }, " Veuillez patientez, nous recherchons les meilleurs prix pour vous... ", -1)
const _hoisted_4 = { style: {"font-size":"0.7em","color":"white","padding":"0.3em 0.5em"} }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"0.4em","text-transform":"none","color":"white","padding":"0.7em","border-radius":"0.3em","background":"rgba(0,0,0,0.44)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Revenir au site ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("article", null, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: "spinner",
            pulse: ""
          })
        ]),
        (typeof this.store.state.error !== 'undefined' && this.store.state.error.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(this.store.state.error) + " ", 1),
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("a", {
                href: this.store.state.base_url + ''
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "home" }),
                _hoisted_9
              ], 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}